import { appGetState } from 'legacy/lut/store'

import { IPaging, IQueryResult } from 'core-components/types'
import { IDataProviderFilter, IFilter, Logic } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

export enum BUSINESS_OPPORTUNITY_FINDER_PRIO {
  CUSTOMER_SIZE = 'spAIOpportunityFinderByCustomerSize',
  INDUSTRY = 'spAIOpportunityFinderByIndustry',
}

export interface IBusinessOpportunityRow {
  rank: number
  revenue: number
  P_Rate_vs_Country: string | null
  YoY_Revenue_Growth: number
  YoY_Revenue_Growth_Market_Power: number
  Baseline_P_Rate: string | null
  partner_counry: string
  PS_Services_Incremental_Revenue: number
  PartnerName: string
  quarter: string
  YoY_Revenue_Growth_Country_Power: number
  Target_Quarter: string
  ps_services_revenue: string | null
  Target_P_ate: string | null
  P_Rate_Increase_Proposal: string | null
  PS_HW_Revenue: string | null
  Avg_Ctry_P_Rate: string | null
  partner_id: string
  Customer_size_employees?: string
  industry?: string
}

export class BusinessOpportunityFinderApi {
  static call = async (
    prio: BUSINESS_OPPORTUNITY_FINDER_PRIO,
    paging: IPaging,
    filter: IDataProviderFilter
  ): Promise<IQueryResult<IBusinessOpportunityRow, string | number>> => {
    const url = proxy(`/webservice/197/sp/v3/${prio}/call`)
    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    const mainFilters: IFilter[] = []
    const additionalFilters = {
      'p.rate_increase_25': 150,
      'p.rate_increase_50': 75,
      'p.rate_increase_75': 50,
      'p.rate_increase_150': 25,
    }

    const filters = filter.filters as IFilter[]

    filters.forEach((f: IFilter) => {
      if (
        f.field === 'rate_increase_150' ||
        f.field === 'rate_increase_75' ||
        f.field === 'rate_increase_50' ||
        f.field === 'rate_increase_25'
      ) {
        additionalFilters[`p.${f.field}`] = f.value ? +f.value : 0
      } else {
        mainFilters.push(f)
      }
    })

    const payload: IObjectAny = {
      take: paging.pageSize,
      skip: paging.page * paging.pageSize,
      'p.filter': JSON.stringify({
        logic: Logic.AND,
        filters: mainFilters,
      }),
      ...additionalFilters,
    }

    const result = await Rest.post({ url, payload, cancelObject: new HttpCancel(), headers })
    return {
      items: result.Rows as IBusinessOpportunityRow[],
      total: result.Total as number,
    }
  }
}
